import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Stack,
  Tooltip,
  Typography,
  type SxProps,
  type Theme,
} from "@mui/material";

type Props = {
  title: string;
  hint: string;
  sx?: SxProps<Theme>;
};

export default function SectionHeader({ title, hint, sx }: Props) {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={[{ alignItems: "center", mb: 1 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <Typography variant="subtitle1">{title}</Typography>
      <Tooltip title={hint}>
        <InfoOutlinedIcon fontSize="inherit" sx={{ color: "text.secondary" }} />
      </Tooltip>
    </Stack>
  );
}
